import { render, staticRenderFns } from "./photoGalleryReasonModal.vue?vue&type=template&id=2308ac18&"
import script from "./photoGalleryReasonModal.vue?vue&type=script&lang=js&"
export * from "./photoGalleryReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports